<template>
  <Card>
    <template #content>
        <div id="overlay" v-if="loading">
          <div class="spinner"></div>
          <br/>
          <h4>Loading...</h4>
        </div>
        <form>
          <!-- <div class="p-grid"> -->
            <div class="p-toolbar p-component mb-4">
              <Button class="p-button p-component p-button-success addNewBtn"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />

            </div>
          <!-- </div> -->
          <Dialog header="Cost Center Group" :visible.sync="displayBasic"
                  :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">

            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="name">Name<span style="color:red">*</span></label>
                <InputText type="text" ref="name" v-model.trim="costCenterGroupName"/>
              </div>
            </div>
            <template #footer>
              <Button class="p-button-raised" :label="editing?'Update':'Add'"
              />
              <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New"
              />
              <Button class="p-button-raised p-button-danger" label="Cancel" @click.prevent="cancel"/>
            </template>
          </Dialog>
        </form>
        <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
          <TreeTable :value="costCenterTree" sortMode="multiple" class="p-datatable-responsive p-datatable-gridlines">
            <Column header="Cost Center" :sortable="true" field="name" :expander="true"></Column>
            <!-- <Column header="Action">
              <template >
                <Button class="p-button-raised p-button-success" icon="pi pi-pencil"
                        @click.prevent="openBasic"
                />
                <Button class="p-button-raised p-button-danger" icon="pi pi-trash"/>
              </template>
            </Column> -->
          </TreeTable>
        </div>
        </div>
    </template>
  </Card>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TreeTable from 'primevue/treetable'
import Column from 'primevue/column'
import Card from 'primevue/card'

export default {
  name: 'CostCenterGroup',
  data() {
    return {
      costCenterGroupName: '',
      editing: false,
      id: null,
      loading: false,
      displayBasic: false
    }
  },
  mounted() {
    this.costCenterTree()
  },
  methods: {
    async costCenterTree() {
      this.loading = true
      let response = await this.$store.dispatch('loadCostCenterForTree', this.toDate)
      this.costCenterTree = response.data.root
      this.loading = false
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.displayBasic = false
    },
    closeBasic() {
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Dropdown,
    Button,
    InputText,
    TreeTable,
    Column,
    Card
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// CostCenterGroup.vue?eec08b30